(function () {
    "use strict";

    // @ngInject
    function NetworkFeedControllerCtor($scope, $injector, $state, $window, $translate, AnalyticsService, CompanyService, ModelFactory, $timeout,
                                       NetworkManager, AppStates, moment, Enums, $stateParams, RepositoryService, DeviceService, GeoLocationHelper,
                                       ModalService, UsersManager, AbTestService, InitialAppLoadParamsService) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'NetworkFeedController';

        this.AnalyticsService = AnalyticsService;

        this.GeoLocationHelper = GeoLocationHelper;

        this.UsersManager = UsersManager;

        this.$stateParams = $stateParams;

        this.isShowServicesOffered =false;
        this.filterInputModel = undefined;

        this.rtsPDF = {
            download_url: "https://hbstatic.honeybook.com/rts_pdf/02_Feb_2018_Growth_Scaling_Collaboration.pdf",
            file_name: "February 2018 - Growth, Scaling and Collaboration.pdf",
            image: "//res.cloudinary.com/honeybook/image/upload/c_scale,f_auto,q_auto:best,w_108/v1519157504/app/community/Growth-Scaling-Collaboration-cover.jpg",
            image_alt: "Growth, Scaling, Collaboration",
            title_text: "Grow & Learn: February",
            body_text: "February’s topic features Growth, Scaling, & Collaboration. This month we are sharing tips about growing your team, partnering with other creatives, and building a strategy that scales."
        };

        this.isMobile = DeviceService.checkIfMobileSize();

        this.CompanyService = CompanyService;
        this.$timeout = $timeout;
        this.$window = $window;
        this.moment = moment;
        this.$state = $state;
        this.DistTypes = Enums.OpportunityDistributionTypes;
        this.RepositoryService = RepositoryService;
        this.NetworkManager = NetworkManager;
        this.ModalService = ModalService;
        this.Enums = Enums;
        this.AbTestService = AbTestService;
        this.InitialAppLoadParamsService = InitialAppLoadParamsService;

        // data to set on initialization after curr network user get
        this.feedLocationCoordinates = [];
        this.isFeedLocationGeocoded = false;
        this.feedLocationLabel = '';
        this.isFeedLocationInputValid = false;
        this.mapLocation = this.feedLocationLabel;
        // end data to set on initialization after curr network user get
        
        this.isLocationFocused = false;

        this.opportunitiesPostedCount = 0;
        this.publishedProjectsCount = 0;
        this.connectionsCount = 0;

        this.currNetworkUser = this.NetworkManager.getNetworkCurrUser();

        this.AppStates = AppStates;
        this.ModelFactory = ModelFactory;

        this.opportunities = ModelFactory.newNetworkReferralsCollection();
        this.projects = ModelFactory.newNetworkProjectsCollection();
        this.showIntro = false;
        this.loadingProjects = true;
        this.loadingOpportunities = true;
        this.myOpportunitiesOnly = false;
        this.hasOwnOpportunities = false;
        this.allOpportunities = false;
        this.allProjects = false;
        this.lastOpportunitiesPage = true;
        this.lastProjectsPage = true;
        this.pinnedObjectId = null;
        this.pinnedObject = null;
        this.isOpportunities = false;
        this.isProjects = false;
        this.justPostedOpportunityId = -1;
        this.openDisableCommentsForId = -1;
        this.isShowingNotificationShared = false;
        this.notificationSharedLocation = "";
        this.showFiltersEditMode = false;
        this.selectedFilters = [];
        this.initializing = true;
        this.filtersUpdate = false;
        this.currUser = UsersManager.getCurrUser();

        this.vendorTypes = Enums.SupportedCreativeTypes.map(function (item) {
            return {key: item.key, name: $translate.instant(item.translationEntry)};
        });

        if ($stateParams.oid) {
            this.pinnedObjectId = InitialAppLoadParamsService.getParam('oid');
        } else if ($stateParams.opportunity_id) {
            this.pinnedObjectId = $stateParams.opportunity_id;
        } else if ($stateParams.opportunity_ids) {
            this.opportunitiesIds = $stateParams.opportunity_ids;
        }


        if (this.pinnedObjectId && InitialAppLoadParamsService.getParam('disable_replies')== '1'){
            this.openDisableCommentsForId = this.pinnedObjectId;
        }

        this.initFeedLocation = function initFeedLocation() {

            var cachedFeedLocationLabel = RepositoryService.persistentGet('feedLocationLabel', '');
            var cachedFeedLocation = RepositoryService.persistentGet('feedLocation', '');

            if (cachedFeedLocationLabel && cachedFeedLocation) {
                this.feedLocationLabel = cachedFeedLocationLabel;
                this.feedLocationCoordinates = cachedFeedLocation;
            }
            else if (this.currNetworkUser.network.coordinates && this.currNetworkUser.network.coordinates.length === 2) {
                this.setFeedLocation(this.currNetworkUser.network.city_state, this.currNetworkUser.network.coordinates);
            }
            else {
                // need to get network user location
                // or for now
                // default to SF if none
                this.setFeedLocation('San Francisco, CA', [-122.4194155, 37.7749295]);
            }

            this.isFeedLocationGeocoded = true;
            this.isFeedLocationInputValid = true;
            this.mapLocation = this.feedLocationLabel;
        }.bind(this);

        if (this.currNetworkUser.network._id) {
            this.initFeedLocation();
            this.initUserFeed();
            this.initUserProfileWidget(this.currNetworkUser.network);
        } else {
            this.currNetworkUser.once('network_user_success', function networkUserFetched() {
                this.initFeedLocation();
                this.initUserFeed();
                this.initUserProfileWidget(this.currNetworkUser.network);
            }.bind(this));
        }

        if (this.currUser.notification_settings) {
            this.updateFromNotificationsSettings();
        }

        this._updateFromNotificationsSettings = this.updateFromNotificationsSettings.bind(this);
        this.UsersManager.on('notificationSettingsUpdated', this._updateFromNotificationsSettings);

        this.filterInputModel = undefined;



        var headerMinHeight = 50;
        var headerMinHeightMediumUp = 76;

        var headerMaxHeight = 230;
        var headerMaxHeightMediumUp = 180;

        this.scrollToHeightTransform = function scrollToHeightTransform(scrollPosition, minHeight, maxHeight) {
            var heightToSet;

            if (scrollPosition === 0) {
                heightToSet = -1;
            } else if (scrollPosition >= (maxHeight - minHeight)) {
                heightToSet = minHeight;
            } else {
                heightToSet = maxHeight - 100 * scrollPosition / 100;
            }

            return heightToSet;
        };

        var headerAnimation = function() {
            var header = angular.element('.js-community-header');
            var hideForHeaderCollapsed = angular.element('.js-hide-for-header-collapsed');
            var bodyWidth = parseInt(angular.element('body').css('width'));
            var minHeight = headerMinHeight;
            var maxHeight = headerMaxHeight;

            // medium up query
            if (bodyWidth > 767) {
                minHeight = headerMinHeightMediumUp;
                maxHeight = headerMaxHeightMediumUp;
            }

            if (header) {
                var locationInput = angular.element('.js-location-input');

                // close google dropdown on scroll
                if (locationInput.is(':focus')) {
                    // directly calling same function as click outside fails
                    angular.element('.network-discover__map-form__label').click();
                    locationInput.blur();
                }

                var scrollTop = angular.element($window).scrollTop();
                var headerHeight = this.scrollToHeightTransform(scrollTop, minHeight, maxHeight);

                if (headerHeight !== -1 && headerHeight < (minHeight + ((maxHeight - minHeight) / 2))) {
                    header.addClass('community-header--collapsed');
                    hideForHeaderCollapsed.addClass('hide-for-header-collapsed');
                } else {
                    header.removeClass('community-header--collapsed');
                    hideForHeaderCollapsed.removeClass('hide-for-header-collapsed');
                }

                if (headerHeight < 0) {
                    headerHeight = '';
                }

                header.css({height: headerHeight});
            }
        }.bind(this);

        angular.element($window).on('scroll', headerAnimation);

        this.updateFilters = function(settings) {
            this.filtersUpdate = true;
            var newSettings = {};
            if (settings) {
                if (settings.selectedFilters) {
                    newSettings.filtered_vendor_types = _.pluck(settings.selectedFilters, 'key');
                }

                if (settings.showServices !== undefined) {
                    newSettings.show_offered_services_opportunities = settings.showServices;
                }
            }
            return this.UsersManager.updateNotificationSettings(newSettings).then(this.refreshOpportunities.bind(this));
        };

        this.refreshOpportunities = function() {
            this.lastCreatedAt = null;
            this.getOpportunities(false);
        };

        $scope.$watchCollection('networkFeedVm.selectedFilters', function (newSelectedFilters, oldSelectedFilters) {
            if (newSelectedFilters !== oldSelectedFilters && !this.initializing) {
                this.updateFilters({'selectedFilters': newSelectedFilters});
            }
        }.bind(this));


        $scope.$on('$destroy', function () {
            this.UsersManager.off('notificationSettingsUpdated', this._updateFromNotificationsSettings);
        }.bind(this));
    }

    Controllers.NetworkFeedController = Class(Controllers.BaseController, {

        constructor: NetworkFeedControllerCtor,

        onChangeShowServicesHandler: function onChangeShowServicesHandler() {
            if (!this.initializing) {
                this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.action,
                    {
                        unique: 'services_offered',
                        page: 'opportunity_filter',
                        value: this.isShowServicesOffered
                    });

                this.updateFilters({'showServices': this.isShowServicesOffered});
            }
        },

        updateFromNotificationsSettings: function updateFromNotificationsSettings() {
            this.subscribedVendorTypes = this.currUser.notification_settings.subscribed_vendor_types;
            this.selectedFilters = this.getVendorTypesByKeys(this.currUser.notification_settings.filtered_vendor_types);
            this.isShowServicesOffered = this.currUser.notification_settings.show_offered_services_opportunities;
            this.notification_radius = this.currUser.notification_settings.notification_radius;
        },

        getVendorTypesByKeys: function getVendorTypesByKeys(keysArray) {
            var selectedVednorTypes = [];
            _.each(this.vendorTypes, function(item) {
                if (keysArray.includes(item.key)) {
                    selectedVednorTypes.push(item)
                }
            });
            return selectedVednorTypes;
        },

        createProject: function createProject() {
            this.goToState(this.AppStates.root_network_create_project);
        },

        toggleOpportunitesFilter: function toggleOpportunitesFilter() {
            this.showFiltersEditMode = !this.showFiltersEditMode;

            if (this.showFiltersEditMode) {
                this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.action,
                    {
                        unique: 'filter_opportunities_feed',
                        page: 'opportunities_tab',
                    });
            }
        },

        initUserFeed: function initUserFeed() {
            this.opportunitiesLoadedDone = false;
            if (this.isCurrUserCityMissing()) {
                this.$state.go(this.AppStates.root_network_edit_profile);
            } else {
                switch (this.$state.current.name) {
                    case this.AppStates.root_network_myopportunities:

                        //set feed location to current user location, so on empty state, location will be set correctly.
                        this.setFeedLocation(this.currNetworkUser.network.city_state, this.currNetworkUser.network.coordinates);

                        this.myOpportunitiesOnly = true;
                        this.isOpportunities = true;
                        this.AnalyticsService.trackPageView(this, 'my posts feed');
                        this.loadingProjects = false;
                        this.getOpportunities();
                        break;
                    case this.AppStates.root_network_opportunities:
                        this.allOpportunities = true;
                        this.isOpportunities = true;
                        this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.load,
                            {
                                unique: 'opportunities_tab',
                                page: 'opportunities_tab'
                            });

                        this.getOpportunities();
                        this.getProjects('published');
                        break;
                    case this.AppStates.root_network_feed_projects:
                        this.allProjects = true;
                        this.isProjects = true;
                        this.AnalyticsService.trackPageView(this, 'projects feed');
                        this.loadingOpportunities = false;
                        this.getProjects();
                        break;
                }
            }
        },

        initUserProfileWidget: function initUserProfileWidget(network) {
            this.opportunitiesPostedCount = network.opportunities_count || 0;
            this.publishedProjectsCount = network.projects_count || 0;
            this.connectionsCount = network.connections_count || 0;
        },

        resetFeedQueryParams: function resetFeedQueryParams() {
            this.InitialAppLoadParamsService.removeParams(['opportunity_id', 'oid', 'opportunity_ids']);
        },

        getProjects: function getProjects(status) {
            this.loadingProjects = true;

            // emit name for header nav title, via network controller broadcast
            this.$scope.$emit('emitPageTitle', 'Published projects near ' + this.feedLocationLabel);

            this.NetworkManager.getUserProjects(
                this.currNetworkUser,
                this.feedLocationCoordinates,
                this.projects,
                this.lastCreatedAt,
                this.pinnedObjectId,
                status
            ).then(function (res) {
                this.loadingProjects = false;
                if (res.collection.length > 0) {
                    this.lastProjectId = res.collection[res.collection.length - 1]._id;
                    this.lastCreatedAt = res.collection[res.collection.length - 1].created_at;
                }
                this.hasOwnOpportunities = res.data.opportunities_count > 0;
                this.lastProjectsPage = res.data.last_page;

                if (!this.pinnedObject && this.pinnedObjectId) {
                    this.pinnedObject = this.pinObject(this.projects, this.pinnedObjectId);
                    this.isPinnedHighlight = true;
                    this.$timeout(function () {
                        this.isPinnedHighlight = false;
                    }.bind(this), 3000);
                }

            }.bind(this));
        },

        pinObject: function pinObject(collection, objectId) {
            var object = null;
            var index = _.findIndex(collection, {_id: objectId})
            if (index !== -1) {
                object = collection[index];
                collection.splice(index, 1);
                collection.unshift(object);
            }
            return object;
        },

        onClickFiltersAddButton: function onClickFiltersAddButton() {
            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.action,
                {
                    unique: 'filter_plus',
                    page: 'opportunity_filter',
                });
        },

        opportunitiesLoaded: function opportunitiesLoaded() {
            this.loadingOpportunities = false;
            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.load, {
                unique: 'opportunity_feed',
                feed_location: this.myOpportunitiesOnly ? 'my_opportunities' : 'community',
                filters_count: this.selectedFilters.length
            });

            if (this.opportunitiesLoadedDone) {
                return;
            }
            this.opportunitiesLoadedDone = true;
        },

        getOpportunities: function getOpportunities(isServerSidePagination) {
            isServerSidePagination = (isServerSidePagination === undefined) ? true : isServerSidePagination;
            this.loadingOpportunities = true;
            this.mapLocation = this.feedLocationLabel;

            if (this.opportunitiesIds) {
                // in case we have opportunity ids in query string, get the corresponding opportunities
                this.NetworkManager.getOpportunitiesByIds(
                    this.currNetworkUser,
                    this.opportunities,
                    this.opportunitiesIds
                ).then(function (res) {
                    this.opportunitiesLoaded();
                }.bind(this)).catch(function (err) {
                    this.opportunitiesLoaded();
                }.bind(this));
            } else {
                this.NetworkManager.getUserOpportunities(
                    this.currNetworkUser,
                    this.feedLocationCoordinates,
                    this.opportunities,
                    this.lastCreatedAt,
                    this.pinnedObjectId,
                    this.myOpportunitiesOnly,
                    this.allOpportunities,
                    isServerSidePagination
                ).then(function (res) {
                    this.opportunitiesLoaded();
                    if (res.collection.length > 0) {
                        this.lastOpportunityId = res.collection[res.collection.length - 1]._id;
                        this.lastCreatedAt = res.collection[res.collection.length - 1].created_at;
                    }
                    //this.hasOwnOpportunities = res.data.opportunities_count > 0;
                    this.hasOwnOpportunities = false;
                    this.lastOpportunitiesPage = res.data.last_page;

                    if (!this.pinnedObject && this.pinnedObjectId) {
                        this.pinnedObject = this.pinObject(this.opportunities, this.pinnedObjectId)
                        this.isPinnedHighlight = true;
                        this.$timeout(function () {
                            this.isPinnedHighlight = false;
                        }.bind(this), 3000);
                    }
                    if (this.initializing) {
                        this.initializing = false;
                    }
                }.bind(this)).catch(function (err) {
                    this.opportunitiesLoaded();
                }.bind(this)).finally(function() {
                    this.filtersUpdate = false;
                }.bind(this));
            }
        },

        loadMore: function loadMore() {
            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.network_feed_load_more);
            if (this.isProjects) {
                this.getProjects();
            } else if (this.isOpportunities) {
                this.getOpportunities();
            }
        },

        dismissIntro: function dismissIntro() {
            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.network_dismiss_feed_intro);
            this.showIntro = false;
            this.NetworkManager.updateNetworkUserProfile(this.currNetworkUser, {dismissed_feed_intro: false});
        },

        isCurrUserCityMissing: function isCurrUserCityMissing() {
            return !this.currNetworkUser.network.city || !this.currNetworkUser.network.coordinates;
        },

        updateFeedLocation: function updateFeedLocation(geoFeedResult, isIsoPost) {
            this.isFeedLocationInputValid = true;

            var targetFeedLocation;
            if (isIsoPost) {
                // iso is posted to location that is not current feed location
                // there is no google geo callback, so use constructed data object passed in
                targetFeedLocation = geoFeedResult;
            } else {
                targetFeedLocation = this.GeoLocationHelper.getGeoLocationData(geoFeedResult);
            }

            if (targetFeedLocation) {
                this.setFeedLocation(targetFeedLocation.locationLabel, targetFeedLocation.coordinates);
                this.isFeedLocationGeocoded = true;
                this.lastCreatedAt = null;
                this.opportunities = this.ModelFactory.newNetworkReferralsCollection();
                this.projects = this.ModelFactory.newNetworkProjectsCollection();
                this.allOpportunities = true;
                this.isOpportunities = true;
                this.myOpportunitiesOnly = false;

                this.resetFeedQueryParams();
                this.getOpportunities();
                this.getProjects();

                this.AnalyticsService.track(this,
                    this.AnalyticsService.analytics_events.success,
                    {
                        unique: 'teleport',
                        is_iso_post: isIsoPost
                    }
                );
            }
        },

        handleClickFeedLocationClear: function handleClickFeedLocationClear() {
            this.setFeedLocation(null);
            this.isFeedLocationInputValid = false;
        },

        handleFeedLocationChanged: function handleFeedLocationChanged() {
            this.isFeedLocationInputValid = false;
        },

        handleFeedLocationBlurred: function handleFeedLocationBlurred() {
            this.isLocationFocused = false;

            if (!this.isFeedLocationInputValid) {
                this.setFeedLocation(this.mapLocation);
            }
        },

        handleClickFeedLocationGoHome: function handleClickFeedLocationGoHome() {
            this.updateFeedLocation({
                locationLabel: this.currNetworkUser.network.city_state,
                coordinates: this.currNetworkUser.network.coordinates
            }, true);
        },

        flashNotificationOpportunityShared: function flashNotificationOpportunityShared() {
            this.isShowingNotificationShared = true;

            this.$timeout(function () {
                this.isShowingNotificationShared = false;
            }.bind(this), 3000);
        },

        handleClickPublishProject: function handleClickPublishProject() {
            this.goToState(this.AppStates.root_network_create_project);
        },

        shouldShowGoHomeButton: function shouldShowGoHomeButton() {
            return this.currNetworkUser.network.coordinates && this.feedLocationLabel !== this.currNetworkUser.network.city_state;
        },

        setFeedLocation: function setFeedLocation(label, coordinates) {

            this.feedLocationLabel = label;

            if (label) {
                this.RepositoryService.persistentPut('feedLocationLabel', label);
            }
            else {
                this.RepositoryService.persistentDelete('feedLocationLabel');
            }

            if (coordinates) {
                this.feedLocationCoordinates = coordinates;
                this.RepositoryService.persistentPut('feedLocation', coordinates);
            }
        },

        openCreateOpportunityModal: function openCreateOpportunityModal(from_source) {
            // when passing 'from_source' parameter. please pick one from the Enums 'CreateOpportunityOptionalSources'

            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.action,
                {
                    unique: 'create_opportunity',
                    page: this.myOpportunitiesOnly ? 'opps_my_posts' : 'opportunities_tab',
                    source: from_source ? from_source : this.Enums.CreateOpportunityOptionalSources.main,
                    vendor_type: this.currNetworkUser.network.vendor_type
                });

            var paramsToPassToModel = {
                isFeedLocationGeocoded: this.isFeedLocationGeocoded,
                feedLocationLabel: this.feedLocationLabel,
                feedLocationCoordinates: this.feedLocationCoordinates
            };

            this.ModalService.openCreateOpportunityModal(paramsToPassToModel)
                .then(function success(result) {

                    if (result && result.status === 'ok') {

                        this.justPostedOpportunityId = result.data.referralId;
                        if ((result.data.isoCoordinates === this.feedLocationCoordinates) ||
                            result.data.isIsoLocationEverywhere) {
                            this.opportunities.unshift(result.data.referral);
                        } else {
                            var targetLocationGeoData = {
                                locationLabel: result.data.isoLocation,
                                coordinates: result.data.isoCoordinates
                            };

                            this.updateFeedLocation(targetLocationGeoData, true);
                        }

                        if (result.data.isIsoLocationEverywhere) {
                            this.notificationSharedLocation = 'in all Locations';
                        } else if (result.data.isIsoLocationGeocoded) {
                            this.notificationSharedLocation = 'near ' + result.data.isoLocation;
                        }

                        this.flashNotificationOpportunityShared();
                    }


                }.bind(this))
                .finally(function final() {

                }.bind(this));
        },


        currentUserCanModerate: function currentUserCanModerate() {
            return this.currNetworkUser.hasCommunityModeratorPermission();
        },

        getProjectThumbnailStyle: function getProjectThumbnailStyle(project) {
            var cover_image = project.getCoverPhoto();

            if (cover_image) {
                return {'background-image': 'url(\"//res.cloudinary.com/honeybook/image/upload/h_120,w_120,c_lfill/' + cover_image.cloudinary_public_id + '.jpg\")'};
            } else {
                return {
                    'background': '#ddd url(\"//res.cloudinary.com/honeybook/image/upload/v1502004950/system_web/rebranding/project-place-holder.svg\") no-repeat',
                    'background-size': '37px 31px',
                    'background-position': 'center center'
                };
            }
        },

        isLocationTeleported: function isLocationTeleported() {
            return this.shouldShowGoHomeButton() && this.isFeedLocationInputValid;
        },

        communityLabelText: function communityLabelText() {
            return this.isLocationTeleported() ? 'The' : 'My';
        }
    });
}());
